import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './service/auth.guard';

import { LoginComponent } from './auth/login/login.component';
import { SignupComponent } from './auth/signup/signup.component';
import { HomeComponent } from './home/home.component';
import { UserWelcomeComponent } from './auth/user-welcome/user-welcome.component';
import { EmailVerificationComponent } from './auth/email-verification/email-verification.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'login', component: LoginComponent },
    { path: 'signup', component: SignupComponent },
    { path: 'home', component: HomeComponent},
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'userwelcome', component: UserWelcomeComponent, canActivate: [AuthGuard]},
    { path: 'emailverification', component: EmailVerificationComponent, canActivate: [AuthGuard] },
    { path: '**', redirectTo: '' },
];

export const AppRoutes = RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' });
